import { Option, OptionValue, OptionUpdatePayload } from 'apis/restaurant-api/merchant-admin/menu2/types';

// Simulate what backend does with an OptionUpdatePayload
const simulateUpdateOptionAPICall = (updatePayload: OptionUpdatePayload, option: Option): Option => {
  const values: OptionValue[] = updatePayload.values.map((valuePayload, index) => ({
    ...valuePayload,
    id: (valuePayload as OptionValue).id || `new-value-${index}`,
  }));

  return {
    default_value:
      (updatePayload.default_value_index && values[updatePayload.default_value_index].id) ||
      updatePayload.default_value ||
      option.default_value,
    external_id: updatePayload.external_id,
    id: option.id,
    menu_id: option.menu_id,
    name: updatePayload.name,
    type: updatePayload.type,
    values,
    version: updatePayload.version,
  };
};

export default simulateUpdateOptionAPICall;
